export const TRINHDO_SET_LIST_DATA = 'TRINHDO_SET_LIST_DATA';
export const TRINHDO_SET_LIST_META = 'TRINHDO_SET_LIST_META';
export const TRINHDO_TITLE = 'Trình độ';